export default "__VITE_ASSET__DOCdLPJA__"